export { default } from "./isMuiElement.mjs";